import React from 'react'
import {
  QuestionnaireAnswerEnum as AnswerEnum,
  QuestionnaireQuestionKeys as QuestionKeys,
  getQuestionByKey,
  QuestionnareFormType,
} from '@modmd/data'
import { fontWeights, fontSizes } from 'theme'
import { Text } from 'components/Typography'
import { Box } from 'components/Layout'
import Button, { ButtonColorVariantType } from 'components/Button'

export interface Props {
  questionnaireForm: QuestionnareFormType
  questionKey: QuestionKeys
  isDisabled?: boolean
}

export const Answers: React.VFC<Props> = ({
  questionnaireForm,
  questionKey,
  isDisabled = false,
}) => {
  const { handleSetQuestionAnswer, questionnaireFormik } = questionnaireForm

  const getButtonColorVariant = ({
    key,
    answerType,
  }: {
    key: QuestionKeys
    answerType: AnswerEnum
  }): ButtonColorVariantType | undefined => {
    const answer = questionnaireFormik.values.surveyResponses.find(
      (response) => response.key === key
    )?.value

    if (answerType === AnswerEnum.NO) {
      return answer === AnswerEnum.NO ? 'info' : 'secondary'
    }
    if (answerType === AnswerEnum.YES) {
      return answer === AnswerEnum.YES ? 'danger' : 'secondary'
    }
    return undefined
  }

  return (
    <>
      <Text fontWeight={fontWeights.semibold} fontSize={fontSizes.l}>
        {getQuestionByKey(questionKey)}
      </Text>
      <Box my="2rem" textAlign="center">
        <Button
          width="7.5rem"
          onClick={() => {
            handleSetQuestionAnswer({
              key: questionKey,
              value: AnswerEnum.NO,
            })
          }}
          colorVariant={getButtonColorVariant({
            key: questionKey,
            answerType: AnswerEnum.NO,
          })}
          disabled={isDisabled}
        >
          NO
        </Button>
        <Button
          ml="0.25rem"
          width="7.5rem"
          onClick={() =>
            handleSetQuestionAnswer({
              key: questionKey,
              value: AnswerEnum.YES,
            })
          }
          colorVariant={getButtonColorVariant({
            key: questionKey,
            answerType: AnswerEnum.YES,
          })}
          disabled={isDisabled}
        >
          YES
        </Button>
      </Box>
    </>
  )
}
